import type { CSSProperties } from 'react'

type Props = {
  depth: number
  label: string
}

export const LOCATION_OPTION_TAB_WIDTH = 12

export const TabbedLocationOption = ({ depth, label }: Props) => (
  <div
    style={
      {
        '--option-tab': `${depth * LOCATION_OPTION_TAB_WIDTH}px`,
      } as CSSProperties
    }
  >
    <span className="pl-[var(--option-tab)]">{label}</span>
  </div>
)
